import React from 'react';
import SIcon from './SIcon';
import { faUserShield } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faUserShield} fa />;

export default Icon;
